// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jG8qBeXAo7DXLm {
  display: flex;
  transition: 0.2s gap ease;
  color: var(--ds-text, #172b4d);
  font-size: 16px;
  text-decoration: none;
  gap: 4px;
}
.jG8qBeXAo7DXLm:hover {
  gap: 8px;
  color: var(--ds-text, #172b4d);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primaryLink": `jG8qBeXAo7DXLm`
};
export default ___CSS_LOADER_EXPORT___;
